export const NS = {};
NS.NS_MODAL_TOGGLE = "NS_MODAL_TOGGLE";
NS.NS_BADGE_UPDATE = "NS_BADGE_UPDATE";
